module.exports = __webpack_public_path__ + "img/icon-owner.68702d5a.svg";